export default __webpack_public_path__ + "e1f56a6ed341559e1fb19dc3767f4605.png";